// frontend/src/components/inbox/ReportView.web.tsx
import React from 'react';

export function ReportView({ html }: { html: string }) {
  // SECURITY: source-link popups are allowed, but report scripts remain
  // blocked. The backend renders first-party markdown with html=False;
  // native-HTML publications will need a separate hardened viewer.
  //
  // The absolute-fill iframe inside a relative flex parent gives a reliable height
  // chain; a bare flex:1 iframe collapses under the Stack header on some browsers.
  return (
    <div style={{ position: 'relative', flex: 1, display: 'flex', minHeight: 0 }}>
      <iframe
        srcDoc={html}
        title="report"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        referrerPolicy="no-referrer"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </div>
  );
}
